:host {
  display: flex;
  align-items: center;
  transform: translateZ(0);
  z-index: 99;
}

::slotted(*) ion-button {
  --padding-top: 0;
  --padding-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
}

::slotted(*) ion-button {
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 8px;
  --padding-end: 8px;
  --box-shadow: none;
  margin-left: 2px;
  margin-right: 2px;
  height: 32px;
  font-size: 14px;
  font-weight: 500;
}
@supports (margin-inline-start: 0) or (-webkit-margin-start: 0) {
  ::slotted(*) ion-button {
    margin-left: unset;
    margin-right: unset;
    -webkit-margin-start: 2px;
    margin-inline-start: 2px;
    -webkit-margin-end: 2px;
    margin-inline-end: 2px;
  }
}

::slotted(*) ion-button:not(.button-round) {
  --border-radius: 2px;
}

:host-context(.ion-color)::slotted(*) .button {
  --color: initial;
  --color-focused: var(--ion-color-contrast);
  --color-hover: var(--ion-color-contrast);
  --background-activated: transparent;
  --background-focused: var(--ion-color-contrast);
  --background-hover: var(--ion-color-contrast);
}

:host-context(.ion-color)::slotted(*) .button-solid {
  --background: var(--ion-color-contrast);
  --background-activated: transparent;
  --background-focused: var(--ion-color-shade);
  --background-hover: var(--ion-color-base);
  --color: var(--ion-color-base);
  --color-focused: var(--ion-color-base);
  --color-hover: var(--ion-color-base);
}

:host-context(.ion-color)::slotted(*) .button-outline {
  --border-color: var(--ion-color-contrast);
}

::slotted(*) .button-has-icon-only.button-clear {
  --padding-top: 12px;
  --padding-end: 12px;
  --padding-bottom: 12px;
  --padding-start: 12px;
  --border-radius: 50%;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  width: 48px;
  height: 48px;
}

::slotted(*) .button {
  --background-hover: currentColor;
}

::slotted(*) .button-solid {
  --color: var(--ion-toolbar-background, var(--ion-background-color, #fff));
  --background: var(--ion-toolbar-color, var(--ion-text-color, #424242));
  --background-activated: transparent;
  --background-focused: currentColor;
}

::slotted(*) .button-outline {
  --color: initial;
  --background: transparent;
  --background-activated: transparent;
  --background-focused: currentColor;
  --background-hover: currentColor;
  --border-color: currentColor;
}

::slotted(*) .button-clear {
  --color: initial;
  --background: transparent;
  --background-activated: transparent;
  --background-focused: currentColor;
  --background-hover: currentColor;
}

::slotted(*) ion-icon[slot=start] {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  margin-right: 0.3em;
  font-size: 1.4em;
}
@supports (margin-inline-start: 0) or (-webkit-margin-start: 0) {
  ::slotted(*) ion-icon[slot=start] {
    margin-right: unset;
    -webkit-margin-end: 0.3em;
    margin-inline-end: 0.3em;
  }
}

::slotted(*) ion-icon[slot=end] {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 0.4em;
  font-size: 1.4em;
}
@supports (margin-inline-start: 0) or (-webkit-margin-start: 0) {
  ::slotted(*) ion-icon[slot=end] {
    margin-left: unset;
    -webkit-margin-start: 0.4em;
    margin-inline-start: 0.4em;
  }
}

::slotted(*) ion-icon[slot=icon-only] {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 1.8em;
}